import { render, staticRenderFns } from "./ProductSliderCard.vue?vue&type=template&id=623be780"
import script from "./ProductSliderCard.vue?vue&type=script&lang=js"
export * from "./ProductSliderCard.vue?vue&type=script&lang=js"
import style0 from "./ProductSliderCard.vue?vue&type=style&index=0&id=623be780&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports